export const MONEY_TYPES = {
  BASIC: '$0,0[.]00',
  DOLLARS: '$0,0',
  SHORT: '0,0',
  DOLLARS_CENTS: '$0,0.00',
  DOLLARS_ONLYIF_CENTS: '$0,0[.]00',
};
